module.exports = __webpack_public_path__ + "2beef81a318d89f28787d4d503a9c52b.svg";